
<!-- 登录失败策略 设置页面 接受三个参数, 主题（用户、角色）id,主题类型 Role or User ,isShow 是否展示页面 -->
<template>
  <div>
    <el-dialog  width="75%" top="5vh" :append-to-body="true" :visible.sync="isShow.show">
        <easyCruds  ref="dataTable"
        @mainTableReload="mainTableReload"
        :tableInfo='conf.mainTable'>
        <template slot-scope="row" slot="operation">
            <el-switch @change="changeAuth(row.row)"  v-model="row.row.__auth_status__" ></el-switch>
        </template>
    </easyCruds>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    const mainTable = {
      header: { title: '登录失败策略设置页(角色、用户)' },
      buttonSetting: {
        allowAdd: false, allowEdit: false, allowDelete: false, allowView: false
      },
      table: { loading: false,
        height: 510,
        stripe: true, columns: [{
          prop: 'name',
          label: '策略名称',
          isSearchCondition: true,
          type: 'input',
          span: 12,
          required: true
        }], operation: { width: 220, slotName: 'operation' }, tableData: [], paging: { currentPage: 1, pageSizes: [10, 15, 20, 25], pageSize: 10, total: 0 }, reload: 'mainTableReload', reloadConditions: {}, addDefultValue: {}}}
    return {
      conf: {
        mainTable
      }
    }
  },
  props: ['isShow', 'id', 'type'],

  components: { },

  methods: {
    /** 主表重载函数 */
    mainTableReload: function(params) {
      this.conf.mainTable.table.loading = true
      let { pageNum = 1, pageSize = 10, name } = params
      this.$http.post('/login-failure-strategy/query', { entity: { name }}, { params: {
        pageNum,
        pageSize
      }}).then(
        response => {
          // response 中是登录策略失败的信息，接下来获取 当前账号已经绑定的策略
          this.$http.post('/login-failure-strategy/bind/list', {
            entity: {
              'bindType': this.type
            }
          }, { params: { bindIdList: this.id }}).then(res => {
            let strategyIdList = res.data.map(item => item.strategyId)
            response.data.records.forEach(item => {
              item.__auth_status__ = !!strategyIdList.includes(item.id)
            })
            this.conf.mainTable.table.tableData = response.data.records
            this.conf.mainTable.table.paging.total = response.data.total || response.data.records.length
            this.conf.mainTable.table.loading = false
          }).catch(error => {
            this.conf.mainTable.table.loading = false
            this.$message.error(error.msg || error.message)
          })
        }
      ).catch(
        error => {
          this.conf.mainTable.table.loading = false
          this.$message.error(error.msg || error.message)
        }
      )
    },
    changeAuth: function(row) {
      this.conf.mainTable.table.loading = true
      let postUrl = row.__auth_status__ ? '/login-failure-strategy/bind' : '/login-failure-strategy/bind/delete'
      this.$http.post(postUrl, null, { params: {
        'bindIdList': this.id,
        loginFailureStrategyBindType: this.type,
        strategyIdList: row.id
      }}).then(response => {
        this.conf.mainTable.table.loading = false
        this.$message.success('操作成功')
      }).catch(error => {
        this.conf.mainTable.table.loading = false
        this.$message.error(error.msg || error.message)
        row.__auth_status__ = !row.__auth_status__
      })
    //
    },
    /** 初始化表格 */
    Initialize: function(params) {
      this.conf.mainTable.table.tableData = []
      this.conf.mainTable.table.paging.total = 0
      this.conf.mainTable.table.paging.currentPage = 1
      this.mainTableReload({})
      this.conf.mainTable.table.reloadConditions = {}
    }
  }
}

</script>
<style lang='scss' scoped>

</style>
